<template>
    <div>
        <section class="material-half-bg">
            <div class="cover"></div>
        </section>
        <section class="login-content">
            <div class="logo">
                <img src="../assets/logo.png" alt="Cocall"/>
            </div>
            <div class="login-box">
                <form @submit="forgot" class="login-form">
                    <h3 class="login-head"><i class="fa fa-lg fa-fw fa-key"></i>{{$t('forgotPass')}}</h3>
                    <form-input :label="$t('email')" type="email" :model="form" attribute="email" :errors="errors" :placeholder="$t('emailPlaceholder')"></form-input>
                    <div class="form-group btn-container">
                        <button @click="forgot" class="btn btn-primary btn-block">
                            {{$t('forgot')}}
                        </button>
                    </div>
                    <p class="semibold-text mt-3"><router-link to="/login">{{$t('login')}}</router-link></p>
                </form>
            </div>
            <lang></lang>
        </section>
    </div>
</template>

<script>
    import Lang from "../components/Lang";

    export default {
        components: {Lang},
        data: function () {
            return {
                form: {},
                errors: {}
            };
        },
        i18n: {
            messages: {
                en: {
                    email: 'Email',
                    emailPlaceholder: 'Your email address',
                    forgot: "Search",
                    forgotPass: 'Forgot Password',
                    login: 'Back to login',
                    successTxt: 'Password recovery request successfully, please check your email to process, Make sure to check spam folder too!',
                    recheck: 'Password recovery instruction have been sent to your email, please double check or wait for 5 minutes to retry!'
                },
                vi: {
                    email: 'Email',
                    emailPlaceholder: 'Email đăng ký tài khoản',
                    forgot: "Tìm lại mật khẩu",
                    forgotPass: 'Quên mật khẩu',
                    login: "Quay lại trang đăng nhập",
                    successTxt: 'Yêu cầu khôi phục mật khẩu thành công, kiểm tra hòm mail của bạn và làm theo hướng dẫn, lưu ý kiểm tra cả spam và inbox!',
                    recheck: 'Hướng dẫn khôi phục mật khẩu đã được gửi vào email của bạn, xin hãy kiểm tra lại hòm mail hoặc đợi 5 phút để thử lại!'
                }
            }
        },

        methods: {
            forgot: function (evt) {
                evt.preventDefault();
                let loader = this.$loading.show();
                this.errors = {};
                this.$service.post('/auth/forgot', this.form).then(response => {
                    if (response.data) {
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t('successTxt'),
                            icon: 'success'
                        }).then(() => {
                            this.$router.push('/login');
                        });
                    } else {
                        this.$swal({
                            title: this.$t('warning'),
                            text: this.$t('recheck'),
                            icon: 'warning'
                        });
                    }
                }).catch(error => {
                    this.errors = error.response.data;
                }).finally(() => {
                    loader.hide();
                });
            }
        }
    };
</script>